export default {
  computed: {
    messageContentAttributes() {
      const { content_attributes: attribute = {} } = this.message;
      return attribute;
    },
    hasAttachments() {
      return !!(
        this.message.attachments && this.message.attachments.length > 0
      );
    },
    isLastMessage() {
      const conversation = Object.values(this.currentChat).filter((item) => (item.content_type?.includes('text') || item?.attachments?.length));
      const lastElement = conversation[conversation.length - 1];

      if (!lastElement || !this.message) {
        return false;
      }

      return lastElement.id == this.message.id;
    },
    isResolved() {
      return this.conversationAttributes.status?.includes('resolved');
    }
  },
};
